module.exports = __webpack_public_path__ + "img/location-pin.6948dc00.svg";